import {Appender, Logger} from "../../types/LoggerTypes";
import {LogLevel} from "@mosaic/logger-service";

export const DEV_NULL_LOGGER_NAME = "DEV_NULL_LOGGER";

/**
 * NoOpLogger implements Logger but performs no operations. It is returned
 * when a requested logger is not registered, preventing callers from
 * needing to null-check logger instances.
 */
export default class NoOpLogger implements Logger {
  bind(appenders: Appender[]): void {}

  component(): string {
    return DEV_NULL_LOGGER_NAME;
  }

  debug(message: string, context?: Record<string, any>): void {}

  info(message: string, context?: Record<string, any>): void {}

  error(message: string, context?: Record<string, any>): void {}

  warn(message: string, context?: Record<string, any>): void {}

  getLevel(): LogLevel {return LogLevel.OFF;}

  setLevel(newLevel: LogLevel): LogLevel {return LogLevel.OFF;}

  getAppenders(): Appender[] {
    return [];
  }

  getThreshold(name: string): LogLevel | undefined {return undefined;}

  setThreshold(name: string, newLevel: LogLevel): LogLevel | undefined { return undefined;}

}
